module.exports = __webpack_public_path__ + "images/directory/icons/customIcon.3a51aece16ac38fdbc16.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/directory/icons/customIcon.png
// module id = 91e1
// module chunks = 1